export const fallbackLng = "nl";
export const languages = ["nl", "en"];
export const cookieName = "boonen-i18next";
export const defaultNS = "common";

export type Language = (typeof Languages)[keyof typeof Languages];

export const Languages = {
  dutch: "nl",
  english: "en",
} as const;

export const availableLanguages = Object.values(Languages);

export type LanguageLocale =
  (typeof languageLocales)[keyof typeof languageLocales];

export const languageLocales = {
  dutch: "nl-NL",
  english: "en-GB",
} as const;

export function getOptions(
  lng = fallbackLng,
  ns: string | string[] = defaultNS,
) {
  return {
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}
